<template>
  <div>
    <app-toolbar class="admin_toolbar" extended />
    <v-main>
      <!-- Page Wrapper -->
      <div v-if="$route.path !== '/'">
        <ad-top />
      </div>
      <div class="page_wrapper"><router-view /></div>
      <div v-if="$route.path !== '/'" class="text-center my-3">
        <router-link :to="{ name: 'TopIndex' }">{{ $t('back_to_top') }}</router-link>
      </div>
      <div>
        <ad-bottom />
      </div>
      <v-container :style="{ 'font-size': '12px' }">
        当サービスは、投資判断の参考となる情報提供を目的としており、投資勧誘を目的としたものではありません。<br />
        当サービスで提供する情報は、信頼できる情報源に基づいて作成されていますが、その正確性、完全性、信頼性を保証するものではありません。<br />
        当サービスの利用によりお客様に生じたいかなる損害についても、当社は一切の責任を負いかねます。
      </v-container>
      <!-- App Footer -->
      <v-footer height="auto" class="pa-3 app--footer theme-footer">
        <v-row justify="center" no-gutters>
          <v-col class="text-center" cols="12"> &copy; SAIO {{ new Date().getFullYear() }} </v-col>
        </v-row>
      </v-footer>
    </v-main>
    <!-- Go to top -->
    <app-fab />
  </div>
</template>

<script>
import AdBottom from '@/components/ad/bottom'
import AdTop from '@/components/ad/top'
import AppToolbar from '@/components/AppToolbar'
import AppFab from '@/components/AppFab'

export default {
  name: 'LayoutDefault',
  components: {
    AdBottom: AdBottom,
    AdTop: AdTop,
    AppToolbar,
    AppFab,
  },
}
</script>
